import {
  Checkbox,
  Heading,
  Page,
  ButtonGroup,
  Button,
  TextField
} from '@superops/ui-design-system';
import { RMMClient, GET_ENTITY_NAMES_META } from '@nile/graphql';

import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  SaveCard,
  Loader,
  TableContainer,
  toast,
  getTranslatedText,
  withErrorBoundary,
  Tag,
  AppContext,
  ALL_TABLES,
  getTableRowCount,
  saveTableRowCount,
  getAllColumnWidth,
  getColumnWidth as superTableColumnWidth,
  saveColumnWidth,
  useProduct,
  COMMON_CONSTANTS,
  updateConditions,
  getUnifiedConditions
} from '@nile/components';
import { TextCell } from '@nile/rmm/src/modules/scripts/components/cells';
import {
  ASSOCIATE_NON_MONITORED_ASSET,
  GET_WORKSTATION_LIST,
  GET_ASSET_LIST_TO_ASSOCIATE_V2
} from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import {
  getVariables,
  checkDynamicQuery,
  getDynamicQuery,
  generateOptions,
  fetchValues,
  getAsyncOptions
} from '@nile/rmm/src/modules/asset-management/services/asset-filter-helper';
import React, { useEffect, useState, useRef, useContext } from 'react';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import PopupHeading from '@nile/rmm/src/modules/it-documentation/components/sub-pages/associated-asset-sheet/associate-popup-heading';
import AssetLinkCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-link-cell';
import AssetStatusCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/asset-status';
import { Tooltip } from 'react-clone-tippy';
import styled from 'styled-components';
import RMMTable from '@nile/rmm/src/modules/common/components/rmm-table/RMMTable';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

import { GET_MONITORED_ASSET_META_INFO } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import {
  constructTableData,
  columnsConfig,
  getNetworkEntityVariables,
  defaultListInfoOptions
} from '@nile/rmm/src/modules/asset-management/components/sub-pages/all-monitored-assets-view/all-monitored-assets-view-helper';
import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import { getProcessedConfig } from '@nile/rmm/src/modules/common/services/tableHelper';
import { cloneDeep, isEmpty, map } from 'lodash';
function AssociatedAssetSheet(props) {
  const {
    intl,
    assetId,
    entityName,
    isRefetchMonitorAsset,
    clientName,
    siteName
  } = props;
  const SelectedItemsWrapper = styled.div`
    background: #ffffff;
    box-shadow: 0px 2px 48px 4px rgb(0 0 0 / 23%);
    border-radius: 10px;
    padding: 15px;
    width: 300px;
    max-height: 500px;
    overflow: auto;
  `;
  const SelectedItem = styled.div`
    padding: 8px 0;
    font-size: 12px;
    white-space: wrap;
  `;
  const flags = useFlags();
  const isITProduct = useCheckIsItProduct();
  const getDefaultClientAndSiteCondition = () => {
    const conditionObj = {
      joinOperator: 'AND',
      operands: []
    };
    if (clientName && !isITProduct) {
      const clientObj = {
        attribute: 'client.name',
        operator: 'includes',
        value: [clientName]
      };
      conditionObj.operands.push(clientObj);
    }
    if (siteName) {
      const siteObj = {
        attribute: 'site.name',
        operator: 'includes',
        value: [siteName]
      };
      conditionObj.operands.push(siteObj);
    }
    return conditionObj.operands.length ? conditionObj : null;
  };
  const [workStations, setWorkStations] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState([]);
  const [filterText, setFilterText] = useState(null);
  const tabContext = useContext(TicketContext);
  const [conditions, setConditions] = useState(null);
  const conditionRef = useRef();
  conditionRef.current = conditions;
  const tableColumns = useRef([
    { Header: 'Name', header: 'Name', columns: [] }
  ]);
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const tableName = ALL_TABLES.itDocAssociate;
  const columnWidthObject = getAllColumnWidth(tableName);
  const ROW_COUNT = getTableRowCount(tableName);
  const [rowCount, setRowCount] = useState(ROW_COUNT);
  const tableRowCount = flags?.itDocAssociateTable ? rowCount : 25;
  const productType = useProduct();
  const defaultListInfo = {
    page: 1,
    pageSize: tableRowCount,
    sort: [
      {
        attribute: 'name',
        order: 'ASC'
      }
    ],
    condition: getDefaultClientAndSiteCondition()
  };
  const [listInfo, setListInfo] = useState(defaultListInfo);

  const [
    fetchMonitoredAssetMetaInfo,
    { loading: metaInfoLoading, error: metaInfoError, data: metaInfoData }
  ] = useLazyQuery(GET_MONITORED_ASSET_META_INFO, {
    client: RMMClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      viewType: ALL_ASSET_TYPES.ALL_ASSETS,
      version: 1
    },
    onCompleted(data) {
      const { configuredCols, allCols } = getProcessedConfig({
        entitiesMeta: entityMeta?.getEntitiesMeta,
        allColumns: data?.getMonitoredAssetsMetaInfo?.selectAttributes,
        intl,
        module: entityName,
        searchAttributes: data?.getMonitoredAssetsMetaInfo?.searchAttributes,
        defaultColumns:
          data?.getMonitoredAssetsMetaInfo?.defaultSelectedAttributes
      });
      const performActions = (col, obj) => {
        if (col === 'detailsView') {
          const {
            assetId: assetDetailsId,
            name,
            assetClass
          } = obj?.row?.original;
          tabContext.openTab({
            module: 'ASSET_DETAILS',
            data: {
              id: assetDetailsId,
              subject: name,
              classId: assetClass?.classId
            }
          });
        }
      };
      const { columnsGroup } = constructTableData(
        configuredCols,
        columnWidthObject,
        data?.getMonitoredAssetsMetaInfo.searchAttributes,
        data?.getMonitoredAssetsMetaInfo.sortAttributes,
        performActions,
        updateAllConditions,
        entityName,
        null,
        null,
        false,
        false,
        false
      );

      let newColumnsGroup = getColumns();
      columnsGroup[0]?.columns?.unshift(...newColumnsGroup);

      tableColumns.current = columnsGroup;
    }
  });

  const {
    data: entityMeta = { getEntitiesMeta: {} },
    loading: entityDataLoading
  } = useQuery(GET_ENTITY_NAMES_META, {
    client: RMMClient,
    variables: {
      entitiesName: getNetworkEntityVariables(ALL_ASSET_TYPES.ALL_ASSETS)
    },
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    onCompleted(data) {
      fetchMonitoredAssetMetaInfo();
    }
  });

  const [
    getAssetsToAssociate,
    { data: assocaitedAssetList, loading }
  ] = useLazyQuery(GET_ASSET_LIST_TO_ASSOCIATE_V2, {
    variables: {
      assetId: assetId,
      entityToAssociate: entityName,
      listInfo: listInfo
    },
    client: RMMClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });
  useEffect(() => {
    const updatedFilterCondition = {
      ...defaultListInfo,
      condition: getDefaultClientAndSiteCondition()
    };
    setListInfo((prevState) => ({ ...prevState, ...updatedFilterCondition }));
  }, [clientName, siteName]);
  useEffect(() => {
    getAssetsToAssociate();
  }, [listInfo]);

  useEffect(() => {
    if (assocaitedAssetList) {
      setWorkStations(assocaitedAssetList.getAssetListToAssociateV2);
    }
  }, [assocaitedAssetList]);

  const [associateSelectedAssets, { loading: associateLoading }] = useMutation(
    ASSOCIATE_NON_MONITORED_ASSET,
    {
      client: RMMClient,
      onCompleted() {
        toast(
          'success',
          getTranslatedText(
            intl,
            'asset.associateAsset.assetAssociated.success'
          )
        );
        props.toggleSheet();
        isRefetchMonitorAsset();
      }
    }
  );

  const udpateAssociation = () => {
    if (selectedAsset.length)
      associateSelectedAssets({
        variables: {
          assetId,
          relatedAsset: {
            entityName,
            assetIds: map(selectedAsset, 'assetId')
          }
        }
      });
  };

  const refreshTable = (context, data) => {
    if (data) {
      const defaultCondition =
        getDefaultClientAndSiteCondition() || data.condition;
      if (data.condition) {
        defaultCondition?.operands.push(data.condition.operands[0]);
      }
      const assetSortBasedOnClientSite = {
        ...data,
        condition: defaultCondition
      };
      setListInfo((prevState) => ({
        ...prevState,
        ...assetSortBasedOnClientSite
      }));
    }
  };

  const handleSelection = (data) => {
    const clonedAssetSelection = cloneDeep(selectedAsset);
    const selectedAssetIndex = clonedAssetSelection.findIndex(
      (a) => a.assetId === data.assetId
    );
    if (selectedAssetIndex !== -1) {
      clonedAssetSelection.splice(selectedAssetIndex, 1);
      setSelectedAsset(() => clonedAssetSelection);
    } else {
      setSelectedAsset((prevState) => [...prevState, data]);
    }
  };
  function constructUnifiedConditions(updatedCondition: any) {
    const params = {
      conditions: listInfo?.condition,
      defaultCondition: getDefaultClientAndSiteCondition(),
      updatedCondition: updatedCondition
    };
    const complexCondition = getUnifiedConditions(params);
    setConditions(updatedCondition);
    setListInfo((prevState) => ({
      ...prevState,
      sort:
        !isEmpty(listInfo) && 'sort' in listInfo
          ? listInfo?.sort
          : defaultListInfoOptions?.sort,
      condition: complexCondition
    }));
  }
  function updateAllConditions(condition, selectedField) {
    updateConditions({
      condition,
      selectedField,
      viewConditions: conditionRef?.current?.operands?.[0] || null,
      setConditions: constructUnifiedConditions
    });
  }
  const removeAsset = (removedAssetId) => {
    const clonedSelection = cloneDeep(selectedAsset);
    const removedAssetIndex = clonedSelection.findIndex(
      (a) => a.assetId === removedAssetId
    );
    if (removedAssetIndex !== -1) {
      clonedSelection.splice(removedAssetIndex, 1);
    }
    setSelectedAsset(clonedSelection);
  };
  const checkRowHighlight = (row) => {
    return selectedAsset.some((el) => el.assetId === row.original.assetId);
  };
  const ActionCell = (props) => {
    const { cell } = props;
    const { original } = cell?.row;
    return (
      <div className="ml-10">
        <Checkbox
          id={original.id}
          checked={selectedAsset.some((el) => el.assetId === original.assetId)}
          onChange={() => {
            handleSelection(original);
          }}
        />
      </div>
    );
  };

  const updatedColumnsConfig = {
    ...columnsConfig,
    LINK: AssetLinkCell,
    ACTION: ActionCell
  };
  function resetFilter() {
    setConditions(null);
    setListInfo({
      page: 1,
      pageSize: tableRowCount,
      condition: getDefaultClientAndSiteCondition()
    });
  }
  const getColumns = () => {
    const cols = [
      {
        name: '',
        label: '',
        key: 'check',
        type: 'ACTION',
        width: 50,
        disableSortBy: true
      }
    ];

    const columns = cols.map((col, idx) => {
      return {
        header: col.label,
        accessorKey: col.key,
        minSize: col.width,
        size: 35,
        Header: col.label,
        accessor: col.key,
        type: col.type,
        id: col.key,
        width: col.width,
        minWidth: col.width,
        disableFilters: true,
        disableSortBy: col.disableSortBy || false,
        field: col,
        className: 'sticky',
        helpers: {
          updateConditions: updateAllConditions
        }
      };
    });
    return columns;
  };

  const getAssetTypeIcon = (assetClassId) => {
    if (assetClassId === '3') {
      return <SVGIcon name="Mac" />;
    }
    if (assetClassId === '1') {
      return <SVGIcon name="Windows" />;
    }
    return '';
  };
  return (
    <div className="full-height no-scroll">
      <div className="vh90 br10 white-bg">
        <div className="fhp">
          <Page
            variant="secondary"
            divider
            title={
              <PopupHeading
                intl={intl}
                filterText={filterText}
                setFilterText={setFilterText}
                selectedAsset={selectedAsset}
                removeAsset={removeAsset}
                conditions={conditions}
                resetFilter={resetFilter}
                defaultListInfo={defaultListInfo}
                refreshTable={refreshTable}
              />
            }
            contentHeight="90px"
            primaryAction={
              <ButtonGroup spacing="loose">
                <div className="mlauto flex center">
                  {selectedAsset?.length > 0 && (
                    <Tooltip
                      distance={5}
                      html={
                        <SelectedItemsWrapper>
                          {selectedAsset.map((el) => {
                            return (
                              <SelectedItem
                                className="flex fx-sb"
                                key={el.assetId}
                              >
                                <div className="ml8 self-start w100 flex fx-sb">
                                  <div className="flex actr">
                                    {getAssetTypeIcon(el.assetClass?.classId)}
                                    <span className="ml-10">{el.name}</span>
                                  </div>
                                  <div className="position-relative z99">
                                    <Button
                                      plain
                                      monochrome
                                      icon={<SVGIcon name="RejectedCircle" />}
                                      onClick={() => {
                                        removeAsset(el.assetId);
                                      }}
                                    />
                                  </div>
                                </div>
                              </SelectedItem>
                            );
                          })}
                        </SelectedItemsWrapper>
                      }
                      position="bottom-end"
                      inertia
                      trigger="mouseenter"
                      animation="shift"
                      interactive
                      animateFill={false}
                      theme="super-light"
                    >
                      <Tag
                        className="ml8 mr8 pointer border-black desc"
                        background="#FFFEF0"
                      >
                        {`${selectedAsset.length} ${getTranslatedText(
                          intl,
                          'admin.serviceCatalog.list.selected'
                        )}`}
                      </Tag>
                    </Tooltip>
                  )}
                </div>
                <Button plainSecondary onClick={props.toggleSheet}>
                  <FormattedMessage id="common.cancel" />
                </Button>
                <Button
                  primary
                  icon={<SVGIcon name="LikeThumb" />}
                  onClick={() => {
                    udpateAssociation();
                  }}
                  loading={associateLoading}
                >
                  <FormattedMessage id="app.action.done" />
                </Button>
              </ButtonGroup>
            }
          >
            <TableContainer>
              <RMMTable
                hideBorderTop
                isLoading={loading}
                context={{}}
                noBulkSelect
                refreshTable={refreshTable}
                columns={tableColumns.current}
                listInfo={listInfo}
                defaultColumnCells={updatedColumnsConfig}
                data={workStations.assets || []}
                pageSize={tableRowCount}
                rowCount={tableRowCount}
                skipPageReset={false}
                pagination={
                  Math.ceil(workStations.listInfo?.totalCount / tableRowCount) >
                  1
                }
                pages={
                  Math.ceil(
                    workStations.listInfo?.totalCount / tableRowCount
                  ) || 0
                }
                activePage={workStations.listInfo?.page || 0}
                recordCount={workStations.listInfo?.totalCount}
                totalCount={workStations.listInfo?.totalCount}
                fullHeight
                listInfoDetails={
                  flags?.itDocAssociateTable
                    ? {
                        ...listInfo,
                        totalCount: workStations.listInfo?.totalCount,
                        pageSize: tableRowCount
                      }
                    : listInfo
                }
                setRowCount={setRowCount}
                tableName={tableName}
                saveColumnWidth={saveColumnWidth}
                saveTableRowCount={saveTableRowCount}
                user={user}
                dynamicRowCount
                columnWidthPersonalization
                ldFlagEnabled={flags?.itDocAssociateTable}
                padded={true}
                defaultOptions={defaultListInfo}
                disableFilters
              />
            </TableContainer>
          </Page>
        </div>
      </div>
    </div>
  );
}

export default withErrorBoundary(injectIntl(AssociatedAssetSheet));
